import {ENV_VARIABLES} from "./index";

export let ENV_LOCAL: ENV_VARIABLES = {
    APP_ENV: "local",
    API_BASE: "https://localhost:44301",
    API_SCOPE: ["api://4003e2c1-bbd8-44f6-be06-b89fde8024d7/access_as_user"],
    CLIENT_ID: "1ce8a365-342d-48d7-bbe2-4992660f5115",
    AUTHORITY: "https://login.microsoftonline.com/852c5799-8134-4f15-9d38-eba4296cc76f",
    REDIRECT_URL: 'http://localhost:3000/login',
    APIM_SUBSCRIPTION_KEY: ''
}
